import React from "react"
import { Outlet } from "react-router-dom"
import Loading from "src/views/Loading"

export const SuspenseRoute = () => (
  <React.Suspense fallback={<Loading />}>
    <Outlet />
  </React.Suspense>
)
